<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :show-footer="true"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      selection
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="licenseNumber"
          title="车牌号"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="150"
          field="driverName"
          title="实际承运人姓名"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="输入实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="oilType"
          title="车辆类型"
          :formatter="formatterAuthStatus"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.oilType" placeholder="请选择" clearable>
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column min-width="100" field="oilPrice" title="行驶公里数" />
      <vxe-table-column
        min-width="100"
        field="oilLitreAmount"
        title="剩余油量"
      />
      <vxe-table-column
        min-width="100"
        field="kilomitreAmount"
        title="邮箱容量"
      />
      <vxe-table-column>
        <vxe-table-column
          field="oilTime"
          title="加油时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fromDate"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import { ctmsVehicleOil } from "@/api/vehicleService";
export default {
  name: "VehicleRefuelConsumption",
  data() {
    return {
      gmtCreatedRange: "",
      gmtAuthRange: "",
      loading: false,
      modelAddShow: false,
      modelEditShow: false,
      modelPlusShow: false,
      typeOptions: [
        { label: "92号", value: 0 },
        { label: "95号", value: 1 },
        { label: "97号", value: 2 },
        { label: "柴油", value: 3 }
      ],
      tableData: [],
      listQuery: {
        staffType: "0", // 类型（托运人）
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      Pagingconf: [],
      sumObject: {
        freezingAmount: 0,
        amount: 0
      }
    };
  },
  created() {
    this.findList();
    let shipmentUserCode = this.$route.query.partyCode;
    this.listQuery.shipmentUserCode = shipmentUserCode;
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        ctmsVehicleOil(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          response.data.total > 10000
            ? (this.Pagingconf = [20, 30, 50, 100, 10000])
            : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
          this.loading = false;
          resolve();
        });
      });
    },
    // 燃油
    formatterAuthStatus({ cellValue }) {
      const item = this.typeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    handleChange(val) {},
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    }
  }
};
</script>

<style>
.vxe-table .vxe-body--column:not(.col--ellipsis),
.vxe-table .vxe-footer--column:not(.col--ellipsis),
.vxe-table .vxe-header--column:not(.col--ellipsis) {
  padding: 6px 0;
}

.vxe-toolbar {
  padding: 0 0 10px 0;
}

.box {
  padding: 10px 20px;
}
</style>
